import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	cardData: [
		{
			id: "",
			code: "",
			name: "",
			startDate: "",
			startDateStr: "",
			endDate: "",
			endDateStr: "",
			duration: 0,
			durationSpan: "",
		},
	],
};

const cardRunningActionsSlice = createSlice({
	name: "cardRunningActions",
	initialState: initialState,
	reducers: {
		updateCard(state, action) {
			// console.log("update cardRunningActions");
			// console.log(action);

			state.cardData = action.payload;
		},
	},
});

export const cardRunningActionsActions = cardRunningActionsSlice.actions;

export default cardRunningActionsSlice;
